export default "__VITE_ASSET__7492dca5__"